/**
 * Live preview of an appearance draft: while a Theme editor has unsaved changes the document shows the
 * draft (themes apply instantly, as in the prototype's custom editor sample); leaving the editor or
 * discarding restores the saved appearance. The plan still decides what renders (`applyAppearance`
 * shows `dark` for a theme the plan does not include), so a preview never unlocks a Pro theme.
 */

import { useLayoutEffect, useRef } from 'react';
import { applyAppearance, type AppearanceInput } from '../../theme/apply.js';

export function useAppearancePreview(saved: AppearanceInput, draft: AppearanceInput, dirty: boolean): void {
  const savedRef = useRef(saved);
  savedRef.current = saved;
  const key = JSON.stringify(dirty ? draft : saved);
  useLayoutEffect(() => {
    applyAppearance(dirty ? draft : saved);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `key` captures both inputs
  }, [key]);
  useLayoutEffect(
    () => () => {
      applyAppearance(savedRef.current);
    },
    [],
  );
}
